/// ///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2026 CONQUER INNOVATIONS SP. Z O.O. Global B.V. and its affiliate(s).
// All rights reserved.
//
// This software and other materials contain proprietary information
// controlled by CONQUER INNOVATIONS SP. Z O.O. and are protected by applicable copyright legislation.
// Any use and utilization of this software and other materials and
// disclosure to any third parties is conditional upon having a separate
// agreement with CONQUER INNOVATIONS SP. Z O.O. for the access, use, utilization or disclosure of this
// software. In the absence of such agreement, the use of the software is not
// allowed.
// The creator, author and originator of the code in the current file: Michał Pawłowski
//////////////////////////////////////////////////////////////////////////////////

import axios from "axios";
import { defineStore } from "pinia";
import { useLazyLoaderModule } from "@/state/pinia/lazyloaderManagerModule";
import { requiredHeaders } from "@/helpers/authservice/requiredHeaders";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import Swal from "sweetalert2";

export const useCommonExportModule = defineStore("commonExportModule", {
    state: () => ({
        lazyLoaderModule: useLazyLoaderModule(),
        import_endpoint_base: "/api/export",
    }),

    actions: {

        httpExportGenericTable(payload) {
            const exportType = payload.exportType; // np. "products"
            const outputFileFormat = payload.outputFileFormat || "XLS";
            const defaultFileNamePrefix = payload.defaultFileNamePrefix || "dane_"

            const endpoint = `/api/export/${exportType}?outputFileFormat=${outputFileFormat}`;

            const body = {
                params: payload.params || {},
                flatExport: payload.flatExport,
                columns: payload.columns
            };

            console.log("Exporting data to file with body: ", endpoint,body);
            this.lazyLoaderModule.setDisplayLazyLoader(true);
            this.lazyLoaderModule.setProgressBarMessage("Trwa eksport danych do pliku...");

            if (outputFileFormat === "XLS" || outputFileFormat === "XLSX") {
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: body,
                    responseType: "blob"
                }).then((response) => {
                    if(response.status === 200){
                        return this.parseFileResource(response, outputFileFormat, defaultFileNamePrefix)
                    }else{
                        return apiRequestsHelper.handleResponseWithDialogs(response, true);
                    }

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpExportGenericTable");
                }).finally(() => {
                    this.lazyLoaderModule.setDisplayLazyLoader(false);
                });
            } else {
                // np. CSV – możesz też dawać blob, ale jeśli backend zwraca tekst, to zostaw jak masz
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: body
                }) .then((response) => {
                   if(response.status === 200){
                       return this.parseFileResource(response, outputFileFormat, defaultFileNamePrefix)
                   }else{
                       return apiRequestsHelper.handleResponseWithDialogs(response, true);
                   }

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpExportGenericTable");
                }).finally(() => {
                        this.lazyLoaderModule.setDisplayLazyLoader(false);
                });
            }
        },
        parseFileResource(response, defaultFileType, defaultFileNamePrefix) {

            //determine the content type from the header or default to octect stream

            // Extract filename from header
            let filename = this.getResourceFileNameFromHeader(response);
            if (filename === null) {
                filename = this.getFileNameToSave(defaultFileType, defaultFileNamePrefix);
            }

            var octetStreamMime = 'application/octet-stream';
            var contentType = response.headers["content-type"] || octetStreamMime;
            var blob = new Blob([response.data], {type: contentType});
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(url);
            return new Promise((resolve) => {
                resolve({isConfirmed: true});
            });

        },
        getResourceFileNameFromHeader(response) {
            // Get the Content-Disposition header
            const contentDisposition = response.headers['content-disposition'];
            let filename = null;
            if (contentDisposition) {
                // 1. Trial to parse filename*=UTF-8'' (the most common situation)
                let matches = /filename\*=UTF-8''([^;]*)/.exec(contentDisposition);
                if (matches && matches[1]) {
                    filename = decodeURIComponent(matches[1]);
                }
                // 2. The trial to parse (RFC 2047: =?UTF-8?Q?...)
                else {
                    matches = /filename="?=\?UTF-8\?Q\?([^?]*)\?="?/i.exec(contentDisposition);
                    if (matches && matches[1]) {
                        // In this format the characters are prefixed with =, np =C5.
                        // JS decodeURIComponent need %, np %C5.
                        // Additional spaces in Q-encoding are often like _, and we have to replace the with actual spaces
                        let messyString = matches[1].replace(/=/g, '%').replace(/_/g, ' ');
                        try {
                            filename = decodeURIComponent(messyString);
                        } catch (e) {
                            console.error("Błąd dekodowania nazwy pliku", e);
                            filename = matches[1]; // Fallbackfor encoded version
                        }
                    }
                    // 3. Ordinary fallback
                    else {
                        matches = /filename="?([^"]*)"?/.exec(contentDisposition);
                        if (matches && matches[1]) {
                            filename = matches[1];
                        }
                    }
                }
            }

            return filename;
        },

        getFileNameToSave(fileType, fileNamePrefix) {
            // get current system millis
            const millis = new Date().getTime();
            //setting default file name
            return fileNamePrefix + "_eksport" + new Date().toLocaleDateString() + "_" + millis + "." + fileType;
        },


    }
});